import { cloneDeep, isNull, isUndefined } from 'lodash-es';
import dayjs, { Dayjs } from 'lib/dayjs';
import { parseNumber } from 'utils/numberFormat';

export const moneyStringToNumber = (str: string | number, defaultValue: number = 0) => {
  const num = parseNumber(str);

  return num || defaultValue;
};

export const generateVoucherCode = () => {
  const code = [];
  const codeList = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];
  for (let i = 0; i < 5; i += 1) {
    const random = Math.floor(Math.random() * codeList.length);
    code.push(codeList[random]);
  }
  return code.join('');
};

export interface ExtraFormValues extends Conversation.Voucher.Vo {
  displayChannel: number;
  times: [Dayjs, Dayjs];
  displayCollectTime: Dayjs;
}

export const voucherVo2FormValuesAdapter = (voucher: Conversation.Voucher.Vo) => {
  const cloneVoucher = cloneDeep(voucher) as ExtraFormValues;

  const { startTime, endTime, ...otherProps } = cloneVoucher;
  if (startTime && endTime) {
    otherProps.times = [dayjs(Number(startTime) * 1000), dayjs(Number(endTime) * 1000)];
  }

  if (cloneVoucher.displayCollectStartTime) {
    otherProps.displayCollectTime = dayjs(Number(cloneVoucher.displayCollectStartTime) * 1000);
  }
  if (cloneVoucher.minBasketPrice) {
    otherProps.minBasketPrice = moneyStringToNumber(cloneVoucher.minBasketPrice);
  }
  if (cloneVoucher.percentage) {
    otherProps.percentage = moneyStringToNumber(cloneVoucher.percentage);
  }
  if (cloneVoucher.maxPrice) {
    otherProps.maxPrice = moneyStringToNumber(cloneVoucher.maxPrice);
  }
  if (cloneVoucher.discountAmount) {
    otherProps.discountAmount = moneyStringToNumber(cloneVoucher.discountAmount);
  }
  if (cloneVoucher.displayChannelList && cloneVoucher.displayChannelList.length > 0) {
    const [displayChannel] = cloneVoucher.displayChannelList;
    otherProps.displayChannel = displayChannel;
  }

  return otherProps;
};

export const voucherFormValues2VoAdapter = (
  formValues: any,
  defaultStoreId: Conversation.Conversation['storeId'],
) => {
  const { times, displayChannel, displayCollectTime, ...values } = formValues;
  if (Array.isArray(times)) {
    const [startTime, endTime] = times as [Dayjs, Dayjs];
    values.startTime = startTime.unix();
    values.endTime = endTime.unix();
  }

  if (displayCollectTime) {
    values.displayCollectStartTime = displayCollectTime.unix();
  }

  values.internalStoreId = values.internalStoreId || defaultStoreId;
  if (displayChannel) {
    values.displayChannelList = [displayChannel];
  }

  return values;
};

export const hasValue = (value: any) => {
  return !isUndefined(value) && !isNull(value);
};
